import { render, staticRenderFns } from "./CommissionDetail.vue?vue&type=template&id=618d2765&scoped=true"
import script from "./CommissionDetail.vue?vue&type=script&lang=js"
export * from "./CommissionDetail.vue?vue&type=script&lang=js"
import style0 from "./CommissionDetail.vue?vue&type=style&index=0&id=618d2765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d2765",
  null
  
)

export default component.exports